import { PricebookCompartments, pricebookStorageKey } from '..';
import { ApiKeys } from '../../../api/apis/ApiKeys';
import { PricebookApi } from '../../../api/apis/PricebookApi';
import { IMutation, MutationContext } from '@aesop-fables/scrinium';
import { PricebookBundle } from '../../../models/PricebookData';
import { ProductTypeCompartments, productTypeStorageKey } from '../../productType';
import { OffboardingCompartments, offboardingStorageKey } from '../../offboarding';

export class SelectPricebook implements IMutation<PricebookBundle> {
  async execute(context: MutationContext<PricebookBundle>): Promise<void> {
    const { data, storage, container } = context;
    const pricebookApi = container.get<PricebookApi>(ApiKeys.Pricebook);
    await pricebookApi.selectOrgPricebook(data.pricebook.id);

    const cache = storage.retrieve<PricebookCompartments>(pricebookStorageKey);
    const productTypeDataCache = storage.retrieve<ProductTypeCompartments>(productTypeStorageKey);
    const offboardingDataCache = storage.retrieve<OffboardingCompartments>(offboardingStorageKey);

    await Promise.all([
      cache.reload('pricebookSelectionIds'),
      productTypeDataCache.reload('paidBy'),
      offboardingDataCache.reload('offboardingTemplate'),
    ]);
  }
}

export class SaveTeamPricebookRestrictions implements IMutation<number[]> {
  async execute(context: MutationContext<number[]>): Promise<void> {
    const { data, storage, container } = context;
    const pricebookApi = container.get<PricebookApi>(ApiKeys.Pricebook);
    await pricebookApi.deleteTeamOptions();
    await pricebookApi.saveTeamOptions(data);

    const cache = storage.retrieve<PricebookCompartments>(pricebookStorageKey);
    await cache.reload('teamAvailablePricebooks');
    await cache.reload('teamPricebooksInUse');
  }
}

export class RevertTeamPricebookRestrictions implements IMutation<void> {
  async execute(context: MutationContext<void>): Promise<void> {
    const { storage, container } = context;
    const pricebookApi = container.get<PricebookApi>(ApiKeys.Pricebook);
    await pricebookApi.deleteTeamOptions();

    const cache = storage.retrieve<PricebookCompartments>(pricebookStorageKey);
    await cache.reload('teamAvailablePricebooks');
    await cache.reload('teamPricebooksInUse');
  }
}

export class SaveOrgPricebookRestrictions implements IMutation<number[]> {
  async execute(context: MutationContext<number[]>): Promise<void> {
    const { data, storage, container } = context;
    const pricebookApi = container.get<PricebookApi>(ApiKeys.Pricebook);
    await pricebookApi.deleteOrgOptions();
    await pricebookApi.saveOrgOptions(data);

    const cache = storage.retrieve<PricebookCompartments>(pricebookStorageKey);
    await cache.reload('orgAvailablePricebooks');
    await cache.reload('pricebookOptions');
  }
}

export class RevertOrgPricebookRestrictions implements IMutation<void> {
  async execute(context: MutationContext<void>): Promise<void> {
    const { storage, container } = context;
    const pricebookApi = container.get<PricebookApi>(ApiKeys.Pricebook);
    await pricebookApi.deleteOrgOptions();

    const cache = storage.retrieve<PricebookCompartments>(pricebookStorageKey);
    await cache.reload('orgAvailablePricebooks');
    await cache.reload('pricebookOptions');
  }
}
